import segment from '@services/segment';
import { analytics } from '@services/analytics';

import { EventProps } from '@services/segment';

export enum ClaimPlayerEvent {
  PLAYER_CLAIMED = 'Player Claimed',
}

const useEventsClaimPlayer = (playerId?: string) => {
  const trackClaimPlayerEvent = (
    event: ClaimPlayerEvent,
    props?: EventProps
  ) => {
    if (import.meta.env.MODE !== 'test') {
      analytics.track(event, {
        playerId,
        ...props,
      });
      segment.track(event, {
        playerId,
        ...props,
      });
    }
  };

  return {
    trackClaimPlayerEvent,
  };
};

export default useEventsClaimPlayer;
